"use client";

import React, { useState } from "react";
import Image from "next/image";
import s from "../styles.parts";
import Consts from "@common/config/consts";
import { logjs, utils } from "@lib/client";
import { usePartsList } from "../usePartsList";

const log = new logjs("PartsListArea");

/**
 * 部品情報表示・編集コンポーネント
 * partslist.ctpをReactに移植した編集フォームコンポーネント
 * 複数行の回答入力、行追加機能、日付ピッカー、ラジオボタントグル機能を含む

 */
export default function PartsListArea({
  form: parentForm,
  formProps: parentFormProps,
  data,
  quote_number,
  photoDialogProps,
  fileupDialogProps,
  qaDialogProps,
  state,
  actions,
  partsData,
  setPartsData,
}) {
  log.debug("START ");

  // フォーム管理フックと共通関数の使用
  const initState = { PartsKindID: -1 };
  const [form, formProps] = usePartsList(initState, state, actions);

  // 部品カテゴリリスト
  const partskind = state?.initData?.partskind || [];

  // 依頼期限の判定  @@TODO 要チェック
  const isAfterCarryTaxinDate = formProps.isAfterCarryTaxinDate(data?.request?.Request_Limit);

  // 現車と紐付いている場合は色変える @@TODO 要チェック
  const isGensha = data?.answer?.[0]?.GenshaID ? true : false;
  const trClass = isGensha ? "gensha" : "";

  const { corp } = state?.initData || {};

  // 損保からの依頼分の表示 @@TODO 要チェック
  const showInsuranceWarning = data?.request?.CorpID?.toString().startsWith("4") && corp?.CorpID && Consts.RE_PARTS_CORP.includes(corp.CorpID);

  /**
   * 保証選択の追加ボタンをクリック　@@TODO 要チェック 未テスト
   * @param {number} i - 部品インデックス
   * @param {number} j - 行インデックス
   */
  const handleAddBikou = (i, j) => {
    const selectId = `hselect_${i}_${j}`;
    const textareaId = `biko_${i}_${j}`;
    const select = document.getElementById(selectId);
    const textarea = document.getElementById(textareaId);
    if (select && textarea) {
      const selectedValue = select.value;
      textarea.value = (textarea.value || "") + selectedValue;
    }
  };

  if (!data) {
    log.debug("data is null");
    return null;
  }

  const _addPartsData = (prid, index, target_key, value) => {
    log.debug(`---------- _addPartsData prid:${prid} index:${index} target_key:${target_key} value:${value}`, partsData);

    setPartsData((prev) => {
      const currentRow = prev[prid] || [];
      const updatedRow = [...currentRow];

      // indexが存在しない場合は初期化
      if (!updatedRow[index]) {
        updatedRow[index] = {};
      }

      // 新しいオブジェクトを作成して更新
      updatedRow[index] = {
        ...updatedRow[index],
        [target_key]: value,
      };

      log.debug("updatedRow", updatedRow);

      return {
        ...prev,
        [prid]: updatedRow,
      };
    });
  };

  return (
    <>
      {/* ヘッダーセクション */}
      <s.PartsTitle>
        <s.FlexRow>
          <div style={{ marginRight: "4px" }}>部品情報</div>
          <s.QuestionButton
            style={{ verticalAlign: "middle", marginTop: "-5px" }}
            onClick={(e) => {
              e.preventDefault();
              qaDialogProps.open({
                MitsumoriNo: quote_number,
                isQuestion: state.user?.Gyoshu_flg === 1,
                request: data?.request,
                answer: data?.answer,
              });
            }}
          >
            依頼元へ質問を行う | 回答を見る
          </s.QuestionButton>
        </s.FlexRow>
        {/* 入庫済み車輌ボタン @@TODO 要チェック 未テスト */}
        {isGensha && (
          <a
            style={{ verticalAlign: "middle", marginTop: "-5px" }}
            className="important-btn4"
            onClick={(e) => {
              e.preventDefault();
              const genshaId = data?.answer?.[0]?.RequestAnswer?.GenshaID;
              formProps.openGenshaDetail(genshaId);
            }}
          >
            <Image src="/images/gensha_icon_w.png" alt="入庫済み車輌" width={20} height={20} />
            入庫済みの車輌があります
          </a>
        )}
      </s.PartsTitle>

      {/* 損保からの依頼分の表示 */}
      {showInsuranceWarning && (
        <>
          <br />
          <font style={{ color: "#ff0000", fontSize: "12pt", fontWeight: "bold" }}>＜損保からの依頼分＞</font>
        </>
      )}

      {/* 部品リストテーブル */}
      {/* PHPテンプレート: <table class="normal order_info"> */}
      <s.PLTable className="normal order_info">
        {data.partsList.map((partsItem, i) => {
          const prid = partsItem?.id;
          const bunruiCD = partsItem?.BunruiCD;
          const tbodyname = `parts${i}`;
          const prSeiyaku = data?.prSeiyaku?.[prid]; // 他社成約フラグ
          const thCol = prSeiyaku ? 11 : 12;
          const thColor = prSeiyaku ? { borderLeftStyle: "none", background: "#696969", color: "#FFF" } : {};

          // 初期値
          const _init_partsData = {
            PartsJyunseiCode: "",
            PartsKindID: -1,
            StanderdPrice: 0,
            Soryo: "",
            Hasso: "",
            Sell_Limit: "",
            ColorNo: "",
            ColorName: "",
            Bikou: "",
            JishaNo: "",
            PrepKind: "",
          };
          const _partsData = partsData[prid] || [_init_partsData];

          log.debug("partsItem", partsItem);
          return (
            <tbody id={tbodyname} key={`parts-${i}`}>
              {/* 部品名ヘッダー行 */}
              <s.PLHeadTr1>
                {/* 他社成約表示 @TODO 要チェック */}
                {prSeiyaku && (
                  <s.PLHeadTh1
                    className={`title ${trClass}`}
                    scope="row"
                    style={{ borderRightStyle: "none", background: "#696969", textAlign: "center", verticalAlign: "middle" }}
                  >
                    <Image src="/images/tasha.png" alt="他社成約" width={120} height={34} />
                  </s.PLHeadTh1>
                )}
                <s.PLHeadTh1 colSpan={thCol} className={`title ${trClass}`} scope="row" style={thColor}>
                  {partsItem?.P_PartsName || ""}

                  {/* 部品カテゴリアイコン */}
                  {(() => {
                    let pk3flg = 1;
                    const pkids = [partsItem?.P_PKID1, partsItem?.P_PKID2, partsItem?.P_PKID4, partsItem?.P_PKID3];
                    const pkName = ["ﾘﾕｰｽ", "ﾘﾋﾞﾙﾄﾞ", "優良新品", "純正新品"];
                    //log.debug(`pkids:${pkids}`, { partsItem, partskind });
                    return (
                      <>
                        {pkids.map((pkid, idx) => {
                          let categoryName = "";
                          categoryName = pkid != null ? formProps.getCategoryName(pkid, partskind) : "　　";
                          let categoryStyle = {};
                          categoryStyle = formProps.getCategoryStyle(pkid);
                          //    log.debug(`idx:${idx} pkid:${pkid} categoryName:${categoryName}  categoryStyle:${categoryStyle.backgroundColor}`, categoryStyle);
                          return (
                            <s.PartsCategoryIcon key={idx} style={categoryStyle}>
                              {categoryName}
                            </s.PartsCategoryIcon>
                          );
                        })}
                      </>
                    );
                  })()}

                  {/* 部品備考 */}
                  {partsItem?.Bikou != null && <div style={{ fontWeight: "normal" }}>({partsItem.Bikou})</div>}
                </s.PLHeadTh1>
              </s.PLHeadTr1>

              {/* 回答データ行（複数行） */}
              {_partsData.map((_partsDataItem, index) => {
                const showColorFields = bunruiCD === 1; // @@TODO 要チェック
                const seqnum = index + 1;

                log.debug("-------------------------------- _partsDataItem", _partsDataItem);
                log.debug(`-------------------------------- _partsDataItem?.PartsKindID:${_partsDataItem?.PartsKindID}`);

                return (
                  <React.Fragment key={`row-${i}-${index}`}>
                    {/* ヘッダー行 */}
                    <s.PLHeadTr2>
                      <s.PLHeadTh2 scope="row">純正品番</s.PLHeadTh2>
                      <s.PLHeadTh2>数量</s.PLHeadTh2>
                      <s.PLHeadTh2>
                        <div>部品カテゴリ</div>
                        <s.RequiredMark src="/images/must.png" alt="必須" />
                      </s.PLHeadTh2>
                      <s.PLHeadTh2>
                        <div>価格(税別)</div>
                        <s.RequiredMark src="/images/must.png" alt="必須" />
                      </s.PLHeadTh2>
                      {isAfterCarryTaxinDate ? (
                        <s.PLHeadTh2>
                          <div>送料(税別)</div>
                          <s.RequiredMark src="/images/must.png" alt="必須" />
                        </s.PLHeadTh2>
                      ) : (
                        <s.PLHeadTh2>
                          <div>
                            送料<span style={{ fontWeight: "bold", backgroundColor: "rgb(255, 255, 0)" }}>(税込)</span>
                          </div>
                          <s.RequiredMark src="/images/must.png" alt="必須" />
                        </s.PLHeadTh2>
                      )}
                      <s.PLHeadTh2>
                        <div>発送可能日</div>

                        <s.RequiredMark src="/images/must.png" alt="必須" />
                      </s.PLHeadTh2>
                      <s.PLHeadTh2>
                        <div>見積有効期限</div>
                        <s.RequiredMark src="/images/must.png" alt="必須" />
                      </s.PLHeadTh2>
                      <s.PLHeadTh2>カラー番号</s.PLHeadTh2>
                      <s.PLHeadTh2>カラー名称</s.PLHeadTh2>
                      <s.PLHeadTh2>写真</s.PLHeadTh2>
                    </s.PLHeadTr2>
                    {/* 入力行 */}
                    <tr>
                      <td scope="row">
                        {formProps.input_PartsJyunseiCode({
                          label: "純正品番",
                          value: _partsDataItem?.PartsJyunseiCode || "",
                          style: { width: "10em" },
                          onChange: (e, params) => {
                            _addPartsData(prid, index, "PartsJyunseiCode", e.target.value);
                          },
                        })}
                      </td>
                      <td style={{ width: "3em" }}>1</td>
                      <td>
                        {formProps.select_PartsKindID({
                          id: `partsKindID_${prid}_${index}`,
                          //defaultValue: _partsDataItem?.PartsKindID || -1,
                          value: _partsDataItem?.PartsKindID || -1,
                          style: { width: "10em" },
                          onChange: (e, params) => {
                            _addPartsData(prid, index, "PartsKindID", e.target.value);
                          },
                        })}
                      </td>
                      <td>
                        {formProps.input_StanderdPrice({
                          value: _partsDataItem?.StanderdPrice || "",
                          style: { width: "10em" },
                          onChange: (e, params) => {
                            _addPartsData(prid, index, "StanderdPrice", e.target.value);
                          },
                        })}円
                      </td>
                      <td>
                        {formProps.input_Soryo({
                          value: _partsDataItem?.Soryo || "",
                          style: { width: "10em" },
                          onChange: (e, params) => {
                            _addPartsData(prid, index, "Soryo", e.target.value);
                          },
                        })}円
                      </td>
                      <td>
                        {formProps.select_Hasso({
                          value: _partsDataItem?.Hasso || "",
                          style: { width: "10em" },
                          onChange: (e, params) => {
                            _addPartsData(prid, index, "Hasso", e.target.value);
                          },
                        })}
                      </td>
                      <td>
                        {formProps.datePicker_Sell_Limit({
                          value: _partsDataItem?.Sell_Limit || "",
                          style: { width: "10em" },
                          onChange: (value, params) => {
                            log.debug("-------------------------------- datePicker_Sell_Limit onChange", { value, params });
                            _addPartsData(prid, index, "Sell_Limit", value);
                          },
                        })}
                      </td>
                      <td>
                        {showColorFields && (
                          <>
                            {formProps.input_ColorNo({
                              value: _partsDataItem?.ColorNo || "",
                              style: { width: "10em" },
                              onChange: (e, params) => {
                                _addPartsData(prid, index, "ColorNo", e.target.value);
                              },
                            })}
                          </>
                        )}
                      </td>
                      <td>
                        {showColorFields && (
                          <>
                            {formProps.input_ColorName({
                              value: _partsDataItem?.ColorName || "",
                              style: { width: "10em" },
                              onChange: (e, params) => {
                                _addPartsData(prid, index, "ColorName", e.target.value);
                              },
                            })}
                          </>
                        )}
                      </td>
                      <td>
                        <s.FlexRow style={{ width: "100%", justifyContent: "center", textAlign: "center", gap: "10px", alignItems: "center" }}>
                          <a onClick={formProps.handlePhotoClick(photoDialogProps, quote_number, prid, seqnum, Consts.WRECKER_PHOTO.KARI_WRT, index)} style={{ cursor: "pointer" }}>
                            <Image src="/images/camera_icon.png" alt="写真" width={24} height={20} />
                          </a>
                          <a onClick={formProps.handleFileupClick(fileupDialogProps, quote_number, prid, seqnum, Consts.WRECKER_PHOTO.KARI_WRT, index)} style={{ cursor: "pointer" }}>
                            <Image src="/images/file_icon.png" alt="ファイル" width={20} height={24} />
                          </a>
                        </s.FlexRow>
                      </td>
                    </tr>

                    {/* 部品備考・自社管理番号行 */}
                    <s.PLHeadTr2>
                      <s.PLHeadTh2 colSpan="9">部品備考</s.PLHeadTh2>
                      <s.PLHeadTh2 scope="row">自社管理番号</s.PLHeadTh2>
                    </s.PLHeadTr2>
                    <tr>
                      <td colSpan="9" style={{ textAlign: "left" }}>
                        {/* 保証選択 @TODO 要チェック */}
                        {data?.hoshoSelect && Object.keys(data.hoshoSelect).length > 0 && (
                          <>
                            {formProps.select(`hselect_${index}`, {
                              value: String(_partsDataItem?.HoshoSelect) || "0",
                              options: formProps.generateHoshoSelectOptions(data.hoshoSelect),
                              style: { width: "100%", float: "left" },
                            })}

                            <s.GrayBtn
                              style={{ marginLeft: "12px" }}
                              onClick={(e) => {
                                e.preventDefault();
                                const _bikou = _partsDataItem?.Bikou || "";
                                const _hoshoSelect = form[`hselect_${index}`];
                                let _value = _bikou + _hoshoSelect;
                                _addPartsData(prid, index, "Bikou", _value);
                              }}
                            >
                              追加
                            </s.GrayBtn>
                          </>
                        )}
                        {/* 部品備考textarea */}
                        {formProps.input_Bikou({
                          value: _partsDataItem?.Bikou || "",
                          style: { width: "100%" },
                          onChange: (e, params) => {
                            _addPartsData(prid, index, "Bikou", e.target.value);
                          },
                        })}
                      </td>
                      <td scope="row" style={{ backgroundColor: "#FDF5E6" }}>
                        {/* 自社管理番号 */}
                        {formProps.input_JishaNo({
                          value: _partsDataItem?.JishaNo || "",
                          style: { width: "10em" },
                          onChange: (e, params) => {
                            _addPartsData(prid, index, "JishaNo", e.target.value);
                          },
                        })}
                        <br />
                        {/* PrepKindラジオボタン */}
                        {formProps.radio_PrepKind({
                          value: String(_partsDataItem?.PrepKind) || "",
                          style: { cursor: "pointer" },
                          name: `${prid}_${index}_PrepKind`,
                          onChange: (e, params) => {
                            //log.debug("-------------------------------- radio_PrepKind onChange", { value: e.target.value, params });
                            if (_partsDataItem?.PrepKind !== e.target.value) {
                              _addPartsData(prid, index, "PrepKind", e.target.value);
                            } else {
                              // 同じ値が選択された場合は空文字列にする
                              _addPartsData(prid, index, "PrepKind", "");
                            }
                          },
                        })}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}

              {/* 行追加ボタン */}
              <tr>
                <td colSpan="10" className="right" scope="row">
                  <s.GrayBtn href="#BikouYZ" style={{ float: "left", fontWeight: "bold" }}>
                    社内用備考を入力する
                  </s.GrayBtn>
                  <s.GrayBtn
                    // href="javascript:void(0)"
                    style={{ float: "right" }}
                    onClick={(e) => {
                      e.preventDefault();
                      //handleAddRow(i);
                      setPartsData((prev) => {
                        const currentRow = prev[prid] || [];
                        const updatedRow = [...currentRow];
                        updatedRow.push({});
                        return {
                          ...prev,
                          [prid]: updatedRow,
                        };
                      });
                    }}
                  >
                    行を追加
                  </s.GrayBtn>
                </td>
              </tr>
            </tbody>
          );
        })}
      </s.PLTable>
    </>
  );
}
